import { NodelMasterData } from "types/models/nodelMaster/NodelMasterApp";

export const GET_NODEL = "GET_NODEL";
export const SET_NODEL_DATA = "SET_NODEL_DATA";

export interface GetNodelAction {
  type: typeof GET_NODEL;
  payload: { data: NodelMasterData[]; total: number };
}

export interface SetNodelDetailAction {
  type: typeof SET_NODEL_DATA;
  payload: NodelMasterData;
}


export type NodelMasterActionTypes =
  | GetNodelAction
  | SetNodelDetailAction
  
